// extracted by mini-css-extract-plugin
export default {"-large":"bIq2kIqC_qhjcDgtxBeu","whiteboardContainer":"PcQlaq_gdTCJz8NOPJzg","relative":"j7UXldBpC83wK31c_k8w"};